import { motion } from 'framer-motion';
import { Users, Award, Briefcase, ArrowRight } from 'lucide-react';

const benefits = [
  {
    icon: Award,
    title: 'Recognised Credential',
    text: 'An AINAA membership is a professional credential — recognised by galleries, publishers, production houses, and institutions as a mark of verified standing.',
  },
  {
    icon: Users,
    title: 'Access to the Network',
    text: 'Connect with a curated community of verified creative professionals. Collaborate, refer, and build relationships built on institutional trust.',
  },
  {
    icon: Briefcase,
    title: 'Career Infrastructure',
    text: 'From contracts to tax guidance, AINAA provides the professional infrastructure that allows you to focus entirely on your creative practice.',
  },
];

const ProofSection = ({ onWaitlistClick }) => {
  return (
    <section
      id="membership"
      className="section-padding relative"
      data-testid="proof-section"
    >
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <p className="section-label mb-5">Membership</p>
          <h2 className="font-['Playfair_Display'] text-3xl sm:text-4xl font-semibold text-[#0F1B2D] tracking-tight">
            Why artists choose to be part of AINAA
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6 mb-16">
          {benefits.map((benefit, index) => (
            <motion.div
              key={benefit.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="inst-card rounded-lg p-8 text-center"
            >
              <div className="w-14 h-14 rounded-lg bg-[#0F1B2D]/5 flex items-center justify-center mx-auto mb-5">
                <benefit.icon size={24} className="text-[#0F1B2D]" />
              </div>
              <h3 className="font-['Playfair_Display'] text-lg font-semibold text-[#0F1B2D] mb-3">
                {benefit.title}
              </h3>
              <p className="text-sm text-[#4A4640] font-medium leading-relaxed">
                {benefit.text}
              </p>
            </motion.div>
          ))}
        </div>

        {/* Application prompt */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          viewport={{ once: true }}
          className="inst-card rounded-lg p-10 text-center max-w-2xl mx-auto"
        >
          <p className="text-[10px] uppercase tracking-[0.25em] text-[#C4A35A] font-bold mb-3">
            By Invitation Only
          </p>
          <h3 className="font-['Playfair_Display'] text-2xl font-semibold text-[#0F1B2D] mb-4">
            Join the waitlist for membership
          </h3>
          <p className="text-sm text-[#4A4640] font-medium leading-relaxed mb-8 max-w-lg mx-auto">
            AINAA membership requires verification by existing trusted members. Submit your details to join the waitlist — once your credibility is verified, you'll be invited to complete the application.
          </p>
          <button
            onClick={onWaitlistClick}
            className="btn-ainaa-primary px-8 py-4 text-sm font-semibold inline-flex items-center gap-2.5 uppercase tracking-wider"
            data-testid="membership-apply-btn"
          >
            Join the Waitlist
            <ArrowRight size={16} />
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default ProofSection;
